export class BuilderStorageConstants {
    static LIVE_CHANGE_SET_NAME = "live_version";
    static TYPE_FIELD_NAME: string = "__type";

    static RULE_SET_INPUT_SUFFIX = "_InputData";
    static RULE_SET_OUTPUT_SUFFIX = "_OutputData";

    static verifyTypeField(d: object) {
        if (!Reflect.get(d, this.TYPE_FIELD_NAME)) throw new Error("missing type field");
    }
}
